export const ROUTE_PATHS = {
  login: 'login',
  passcode: 'passcode',
  purchaseOrders: 'purchase-orders',
  purchaseOrderDetail: 'purchase-detail-order',
  rejectedEmail: 'rejected-email',
} as const;
